// extracted by css-extract-rspack-plugin
export default {"tier":"Zizdvf","tier-info":"Ekg80h","tierInfo":"Ekg80h","title":"bh2ReI","subscribers":"oNm_Xw"};